import  React from 'react'
import { GrantAgreementDetailModel } from '../../models/GrantAgreementDetailModel'

type Props = {
  model: GrantAgreementDetailModel
}

const ApplicationSummary: React.FC<Props> = ({ model }) => {
  const {
    grantee, grantAgreementNumber, round, grantType,
  } = model
  return (
    <div className="emdg-callout mt-3 mb-4">
      <div className="row">
        <div className="col-lg-1 col-md-12 d-flex">
          <strong>Grantee</strong>
        </div>
        <div className="col-lg-5 col-md-12 d-flex mb-2">
          {grantee}
        </div>
        <div className="col-lg-3 col-md-12 d-flex">
          <strong>Grant Agreement  Number</strong>
        </div>
        <div className="col-lg-3 col-md-12 d-flex mb-2">
          {grantAgreementNumber}
        </div>
      </div>
      <div className="row">
        <div className="col-lg-1 col-md-12 d-flex">
          <strong>Round</strong>
        </div>
        <div className="col-lg-5 col-md-12 d-flex mb-2">
          {round}
        </div>
        <div className="col-lg-3 col-md-12 d-flex">
          <strong>Type of Grant</strong>
        </div>
        <div className="col-lg-3 col-md-12 d-flex mb-2">
          {grantType}
        </div>
      </div>
    </div>
  )
}

export default ApplicationSummary
